import { render, staticRenderFns } from "./ListGroupItem.vue?vue&type=template&id=de2e9ea8&"
import script from "./ListGroupItem.vue?vue&type=script&lang=ts&"
export * from "./ListGroupItem.vue?vue&type=script&lang=ts&"
import style0 from "./ListGroupItem.vue?vue&type=style&index=0&id=de2e9ea8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports